$(document).ready(function(){

	$('a[href^="#manage-cookies"]').on('click', function(e){
		e.preventDefault();
		if (window.CookieConsent && typeof CookieConsent.showPreferences === 'function') {
			CookieConsent.showPreferences();
		}
	});	

	$('a[href^="#"]').on('click', function(e){
		e.preventDefault();
		var id = $(this).attr("href");
	 	if ($(id).length) {
			$('html, body').animate({
				scrollTop: $(id).offset().top - 30
			}, 'slow');
			$(id).focus();
		}
	});

});
